exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ff-raanan{font-family:raanancondensed}.gc-container{background:#f3d6d8}.gc-wrapper{max-width:1570px;padding:0 1rem;margin:0 auto}@media screen and (max-width:767px){.gc-wrapper{max-width:auto;padding:0 1.5rem}}@media screen and (max-width:767px){.acsb-trigger{display:none!important}}", ""]);

// exports
